import React, { Component } from 'react';
import {
  Typography,
  createStyles,
  WithStyles,
  withStyles,
  Grid,
  CardContent,
  Card,
  Theme
} from '@material-ui/core';

import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import UserCard from './UserCard';
import { getReviewees } from '../actions/dashboardAction';
import { UserBody } from '../types/UsersBody';


const styles = (theme: Theme) => createStyles({
  mt1x: {
    marginTop: theme.spacing.unit * 2,
    MozBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
    WebkitBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
  },
  cardMain: {
    height: 543,
    position: 'relative',
    overflowY: "auto",
    overflowX: "hidden",
  },
  cardContentRoot: {

  },
  UserCard: {
    padding: "5px !important",
  },
  noContent: {
    margin: 0,
    position: "absolute",
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  }
});

interface MyRevieweeProps extends WithStyles<typeof styles> {
  getReviewees: () => void,
  revieweesList: UserBody[]
}

interface MyRevieweeState {

}

class MyReviewee extends Component<MyRevieweeProps, MyRevieweeState> {


  componentDidMount() {
    this.props.getReviewees();
  }

  render() {
    const { classes, revieweesList } = this.props;
    return (
      <Card className={`${classes.mt1x} ${classes.cardMain}`}>
        <CardContent className={classes.cardContentRoot}>
          <Grid item xs>
            <Typography variant="h5" noWrap>
              My Reviewee
                </Typography>
          </Grid>

          {
            revieweesList && revieweesList.length > 0 ?
              (_.map(revieweesList, (reviewee: UserBody, i: number) => (
                <Card className={classes.mt1x} key={`revieweesList-${i}`}>
                  <CardContent className={classes.UserCard}>
                    <UserCard
                      key={`${reviewee._id}_${i}`}
                      name={`${reviewee.firstName} ${reviewee.lastName}`}
                      role={reviewee.roles.length > 0 ? reviewee.roles[0].roleId.role : ''}
                      lastActivityAt={reviewee.lastActivityAt}
                      imgSrc={reviewee.profileImage}
                    />
                  </CardContent>
                </Card>
              ))
              )
              : <Typography className={classes.noContent} color="textSecondary">No Reviewee</Typography>

          }

        </CardContent>
      </Card>
    )
  }
}

const mapStateToProps = (state: any) => ({
  revieweesList: _.get(state, 'dashboardData.dashboard.reviewees', []),
});


const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  getReviewees,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MyReviewee));

